(function() {
  var headerSelectors = [
    '.section-header.shopify-section-header-sticky',
    '.section-header',
    'sticky-header.header-wrapper',
    '.section-header .header-wrapper',
    '[data-tcgsync-header]',
    '.tcg-header',
    '.header-wrapper'
  ];

  var navSelectors = [
    'nav[class*="mega-nav-section-"]',
    '.mega-menu-navigation-section nav[class*="mega-nav-section-"]',
    '.mega-menu-navigation-section',
    '[class*="mega-nav-section-"]'
  ];

  function firstVisible(selectors) {
    for (var i = 0; i < selectors.length; i += 1) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j += 1) {
        var el = nodes[j];
        var rect = el.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) return el;
      }
    }
    return null;
  }

  function syncStickyShell() {
    var header = firstVisible(headerSelectors);
    var nav = firstVisible(navSelectors);
    if (!header) return;

    document.querySelectorAll('.innernerd-fixed-header').forEach(function(el) {
      if (el !== header) el.classList.remove('innernerd-fixed-header');
    });
    document.querySelectorAll('.innernerd-fixed-nav').forEach(function(el) {
      if (el !== nav) el.classList.remove('innernerd-fixed-nav');
    });

    header.classList.add('innernerd-fixed-header');
    if (nav) nav.classList.add('innernerd-fixed-nav');
    document.body.classList.add('innernerd-fixed-shell');

    var headerHeight = Math.ceil(header.getBoundingClientRect().height || 0);
    var navHeight = nav ? Math.ceil(nav.getBoundingClientRect().height || 0) : 0;
    var headerBottom = Math.max(0, Math.ceil(header.getBoundingClientRect().bottom || headerHeight));
    var navTop = headerBottom;
    var stackHeight = Math.max(0, navTop + navHeight);

    document.documentElement.style.setProperty('--innernerd-header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--innernerd-nav-height', navHeight + 'px');
    document.documentElement.style.setProperty('--innernerd-nav-top', navTop + 'px');
    document.documentElement.style.setProperty('--innernerd-fixed-stack-height', stackHeight + 'px');
  }

  function setupBackToTop() {
    var button = document.getElementById('innernerd-back-to-top') ||
      document.querySelector('.top_button.innernerd-back-to-top') ||
      document.querySelector('.top_button');
    if (!button) {
      button = document.createElement('a');
      button.href = '#';
      button.className = 'top_button';
      document.body.appendChild(button);
    }

    button.id = 'innernerd-back-to-top';
    button.classList.add('innernerd-back-to-top');
    button.setAttribute('aria-label', 'Back to top');
    button.setAttribute('title', 'Back to top');
    button.removeAttribute('hidden');
    button.style.removeProperty('display');
    button.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 10 6"><path fill="currentColor" d="M9.35.65a.5.5 0 0 0-.7 0L5 4.29 1.35.65a.5.5 0 1 0-.7.7l4 4a.5.5 0 0 0 .7 0l4-4a.5.5 0 0 0 0-.7Z"/></svg>';

    function toggle() {
      var shouldShow = window.scrollY > Math.max(360, window.innerHeight * 0.65);
      button.classList.toggle('is-visible', shouldShow);
      button.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    button.addEventListener('click', function(event) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
  }

  function init() {
    syncStickyShell();
    setupBackToTop();

    if (window.ResizeObserver) {
      var header = firstVisible(headerSelectors);
      var nav = firstVisible(navSelectors);
      var observer = new ResizeObserver(syncStickyShell);
      if (header) observer.observe(header);
      if (nav) observer.observe(nav);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', syncStickyShell);
  window.addEventListener('scroll', syncStickyShell, { passive: true });
  window.addEventListener('resize', syncStickyShell);
  document.addEventListener('shopify:section:load', function() {
    setTimeout(syncStickyShell, 50);
  });
})();
